import React from "react";
import { Navigate } from "react-router-dom";

const isAuthenticated = () => {
  return !!(localStorage.getItem("authToken") || localStorage.getItem("userDetail"));
};

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
